import { render, staticRenderFns } from "./ShareSection.vue?vue&type=template&id=154929fd&"
import script from "./ShareSection.vue?vue&type=script&lang=js&"
export * from "./ShareSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports